import { render, staticRenderFns } from "./MyMindRightMenu.vue?vue&type=template&id=788b6afa&scoped=true"
import script from "./MyMindRightMenu.vue?vue&type=script&lang=js"
export * from "./MyMindRightMenu.vue?vue&type=script&lang=js"
import style0 from "./MyMindRightMenu.vue?vue&type=style&index=0&id=788b6afa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788b6afa",
  null
  
)

export default component.exports